import {DataPoint} from '../App';
import {Marker} from '../components/MapChart';

export interface InstitutionsGroup {
  [name: string]: DataPoint[];
}

export const groupAndFilterData = (
    data: DataPoint[],
    groupBy: keyof DataPoint,
    searchValue?: string,
) => {
  // Grouped by city
  const grouped: {
    [key: string]: InstitutionsGroup;
  } = {};

  data.forEach((dataPoint) => {
    if (!grouped[dataPoint.Location]) {
      grouped[dataPoint.Location] = {};
    }
    if (
      !grouped[dataPoint.Location][dataPoint.Entity]
    ) {
      grouped[dataPoint.Location][dataPoint.Entity] =
        [];
    }
    grouped[dataPoint.Location][dataPoint.Entity].push(
        dataPoint,
    );
  });
};


export const getMarkerSize = (marker: Marker): number => {
  let investedSum = isNaN(Number(marker.investedSum)) ? 0 : Number(marker.investedSum);
  marker.children.forEach((marker) => {
    investedSum += isNaN(Number(marker.investedSum)) ? 0 : Number(marker.investedSum);
  });
  if (isNaN(investedSum)) {
    return 8;
  }
  if (investedSum < 10) {
    return 8;
  }
  if (investedSum < 50) {
    return 12;
  }
  if (investedSum < 100) {
    return 15;
  }
  if (investedSum < 500) {
    return 18;
  }
  if (investedSum < 1000) {
    return 22;
  }
  if (investedSum < 1500) {
    return 26;
  }
  if (investedSum < 5100) {
    return 30;
  }
  return 40;
};

export const getFriendlyProductStatus = (
    status: string,
) => {
  if (status.toLowerCase() === 'live') {
    return 'In production';
  } else if (status.toLowerCase() === 'future') {
    return 'Planned';
  }
  return status;
};

export const displayInvestment = (investment: Marker | string) => {
  if (typeof investment === 'string') {
    return isNaN(Number(investment)) ? 'Not disclosed' : `${investment} mln EUR`;
  }

  if (investment.children.length === 0) {
    return isNaN(Number(investment.investedSum)) ? 'Not disclosed' : `${investment.investedSum} mln EUR`;
  }

  // If there are children, sum the invested sums
  let investedSum = 0;
  investment.children.forEach((marker) => {
    investedSum += isNaN(Number(marker.investedSum)) ? 0 : Number(marker.investedSum);
  });
  if (isNaN(investedSum)) {
    return 'Not disclosed';
  }
  if (investedSum < 1) {
    return '<1 mln EUR';
  }

  return `${investedSum} mln EUR`;
};
